import { render, staticRenderFns } from "./SummarySection.vue?vue&type=template&id=469694f8&scoped=true"
import script from "./SummarySection.vue?vue&type=script&lang=js"
export * from "./SummarySection.vue?vue&type=script&lang=js"
import style0 from "./SummarySection.vue?vue&type=style&index=0&id=469694f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469694f8",
  null
  
)

export default component.exports